import { Creator, GetCreatorsResponse, GetUploadUrlResponse } from './types'
import { CreatorFragment, CreatorMetadataFragment } from './fragments/creators'
import { gql } from '@apollo/client'
import { PaginationFragment } from './common'

export const UPDATE_CREATOR = gql`
  mutation UpdateCreator($id: Int!, $input: UpdateCreatorInput!) {
    updateCreator(id: $id, input: $input) {
      ...CreatorFragment
    }
  }
  ${CreatorFragment}
`

export const GET_CREATOR_INTRO_VIDEO_UPLOAD_URL = gql`
  mutation GetCreatorIntroVideoUploadUrl($creatorId: Int!, $mime: String!) {
    getCreatorIntroVideoUploadUrl(creatorId: $creatorId, mime: $mime) {
      uploadUrl
      fileName
    }
  }
`

export const PAUSE_CREATOR = gql`
  mutation PauseCreator($id: Int!, $input: PauseCreatorInput!) {
    pauseCreator(id: $id, input: $input) {
      ...CreatorFragment

      metadata {
        ...CreatorMetadataFragment
      }
    }
  }

  ${CreatorFragment}
  ${CreatorMetadataFragment}
`

export const UNPAUSE_CREATOR = gql`
  mutation UnpauseCreator($id: Int!) {
    unpauseCreator(id: $id) {
      ...CreatorFragment

      metadata {
        ...CreatorMetadataFragment
      }
    }
  }

  ${CreatorFragment}
  ${CreatorMetadataFragment}
`

export const REQUEST_APPROVAL = gql`
  mutation RequestApproval($id: Int!) {
    requestApproval(id: $id) {
      id
      status
      pausedReason
    }
  }
`

export const GET_CREATOR_EARNINGS = gql`
  query GetCreatorEarningsByCreatorId($creatorId: Int!) {
    getCreatorEarningsByCreatorId(creatorId: $creatorId) {
      creator {
        ...CreatorFragment
      }
      earnings {
        totalEarningCents
        totalPaymentCents
        totalPendingPaymentCents
        currency
      }
    }
  }
  ${CreatorFragment}
`

export const GET_CREATORS_BY_BRAND = gql`
  query GetCreatorsByBrand($brandId: Int!) {
    getCreatorsByBrand(brandId: $brandId) {
      id
      firstName
      lastName
      avatar {
        url
        name
      }
    }
  }
`

export const GET_CREATORS_BY_BRAND_WITH_CLIPS = gql`
  query GetCreatorsByBrandWithClips($brandId: Int!) {
    getCreatorsByBrandWithClips(brandId: $brandId) {
      id
      firstName
      lastName
      avatar {
        url
        name
      }
    }
  }
`

export const GET_CREATORS_BY_CAMPAIGN_WITH_CLIPS = gql`
  query GetCreatorsByCampaignWithClips($campaignId: Int!) {
    getCreatorsByCampaignWithClips(campaignId: $campaignId) {
      id
      firstName
      lastName
      avatar {
        url
        name
      }
    }
  }
`

export const GET_CREATORS_WITH_LAST_INTRO_VIDEO_EXAMPLES = gql`
  query GetCreatorsWithLastIntroVideoExamples {
    getCreatorsWithLastIntroVideoExamples {
      items {
        ...CreatorFragment
      }
      pagination {
        ...PaginationFragment
      }
    }
  }
  ${CreatorFragment}
  ${PaginationFragment}
`

export const GET_CREATOR_BY_UUID = gql`
  query GetCreatorByUuid($uuid: String!) {
    getCreatorByUuid(uuid: $uuid) {
      ...CreatorFragment
    }
  }
  ${CreatorFragment}
`

export interface UpdateCreatorResponse {
  updateCreator: Creator
}

export interface GetCreatorByUuidResponse {
  getCreatorByUuid: Creator
}

export interface GetCreatorIntroVideoUploadUrlResponse {
  getCreatorIntroVideoUploadUrl: GetUploadUrlResponse
}

export interface QueryGetCreatorsByBrandResponse {
  getCreatorsByBrand: Creator[]
}

export interface QueryGetCreatorsByBrandWithClipsResponse {
  getCreatorsByBrandWithClips: Creator[]
}

export interface QueryGetCreatorsByCampaignWithClipsResponse {
  getCreatorsByCampaignWithClips: Creator[]
}

export interface GetCreatorsWithLastIntroVideoExamplesResponse {
  getCreatorsWithLastIntroVideoExamples: GetCreatorsResponse
}
